<template>
  <div class="snail_fourth_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show='count < 100'>
        <div class="title"></div>
        <div class="loading_bg">

          <div class="loading">
            <div class="loading_line"></div>
          </div>
          <div class="loading_text" />
          <div class="change_text">{{ count }}%</div>
        </div>
      </div>
    </transition>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      @onOfficial="onOfficial" />
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')" ref="bg">

      <div class="index" ref="myDiv">
        <div class="main_01" id="#0" ref="myDiv0">
          <div class="title" />
          <div class="logo" />


        </div>
        <div class="main_02">
          <div class="head_box"></div>
          <div class="content">

            <div class="text" />
            <div class="reward_items">
              <div class="reward_item" v-for="item in  fourth_reward " :key="item.key"
                :style="{ 'background-position': item.position }" />
            </div>
            <div class="team_text" />
            <div class="btn_items">
              <div class="btn_item" @click="item_click('offical')" />

              <div class="btn_item enter" @click="item_click('enter')" />
            </div>

          </div>

        </div>
        <div class="bottom" />
      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 信息列表 -->
    <div class="rule_wrap popup_wrap" v-show="showImgShow" @click="closePopup('showImgShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="showImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 公众号列表 -->
    <div class="code_wrap popup_wrap" v-show="codeImgShow" @click="closePopup('codeImgShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="codeImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 领取确认 -->
    <div class="sure_wrap popup_wrap" v-show="sureShow" @click="closePopup('sureShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="sureImg" alt="详情">
            <div class="sure_text">
              <div>该奖励仅可领取一次</div>
              <div>当前将领取到xxx服xxx角色</div>
            </div>
            <div class="btn_box">
              <div class="sure_btn"></div>
              <div class="switch_btn"></div>

            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 信息列表 -->
    <div class="copy_wrap popup_wrap" v-show="copyShow" @click="closePopup('copyShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="copyImg" alt="详情">
            <div class="link">
              <div class="link_text">
                {{ shareLink }}
              </div>
              <a id="link_btn" href="javascript:;" class="link_btn" i @click="onCopy('#link_btn')"
                :data-clipboard-text='"就差你了！超爽肉鸽像素弹幕射击游戏《迷途之光》6月1日上线，点击下方链接加入小队预约游戏领海量奖励！" + shareLink'></a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, invite, teamInit } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
// import Header from '@/components/Header';

// import eruda from 'eruda';

export default {
  name: 'order',
  components: {
    Header,
    Login,
    Os,
    swiper,
    swiperSlide,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'mzzg',
      is_access_token: '',
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      hotNum: 0,
      count: 40,
      task_list: [
        {
          "id": 1,
          "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
          "status": false,
          "package_id": 1,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 2,
          "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
          "status": false,
          "package_id": 2,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 3,
          "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
          "status": false,
          "package_id": 3,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 4,
          "name": "\u9080\u8bf7\u597d\u53cb",
          "status": false,
          "package_id": 4,
          "num": 2,
          "is_get_reward": false
        }
      ],
      fourth_reward: [
        {
          position: '0% 0%',
        },
        {
          position: '20% 0%',
        },
        {
          position: '40% 0%',
        },
        {
          position: '60% 0%',
        },
        {
          position: '80% 0%',
        },
        {
          position: '100% 0%',
        },
      ],
      anniversary_reward: [
        {
          position: '0% 0%',
        },
        {
          position: '0% 0%',
        },
        {
          position: '0% 0%',
        },
        {
          position: '0% 0%',
        },
        {
          position: '0% 0%',
        },
      ],
      task_item: [
        {
          position: '0% 0%',
          key: 1,
        },
        {
          position: '0% 50%',
          key: 2,
        },
        {
          position: '0% 100%',
          key: 3,
        },

      ],
      opt_item: [
        {
          position: '0% 0%',
          key: '1',
          name: 'qq'
        },
        {
          position: '50% 0%',
          key: 2,
          name: 'tap'
        },
        {
          position: '100% 0%',
          key: 3,
          name: 'wx'
        },

      ],
      click_item_active: 1,
      click_items: [
        {
          item_position: '0% 0%',
          key: 1,
          item_out_position: '0% 0%'
        },
        {
          item_position: '0% 25%',
          key: 2,
          item_out_position: '0% 25%'
        },
        {
          item_position: '0% 50%',
          key: 3,
          item_out_position: '0% 50%'
        },
        {
          item_position: '0% 75%',
          key: 4,
          item_out_position: '0% 75%'
        },
        {
          item_position: '0% 100%',
          key: 5,
          item_out_position: '0% 100%'
        },
      ],
      other_items: [
        {
          position: '0% 0%',
          key: 1,
        },
        {
          position: '0% 50%',
          key: 2,
        },
        {
          position: '0% 100%',
          key: 3,
        },

      ],
      messageImg: '',
      isPC: false,
      selectInfo: {},
      isExpanded: true,
      codeShow: false,
      messageShow: false,
      wxLoadShow: false,
      isUserInfo: false,
      shareLink: '',
      user_info: {},
      observer: null,
      loopInt: null,
      rewardSum: 0,
      activity: {
        "invitation": [
        ],
        "task_list": [
          {
            "id": 1,
            "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
            "status": false,
            "package_id": 1,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 2,
            "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
            "status": false,
            "package_id": 2,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 3,
            "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
            "status": false,
            "package_id": 3,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 4,
            "name": "\u9080\u8bf7\u597d\u53cb",
            "status": false,
            "package_id": 4,
            "num": 2,
            "is_get_reward": false
          }
        ],
        "code": "feHrfhzH",
        "reward_start": false,
        "url_scheme": "weixin:\/\/dl\/business\/?t=o4RzaIEHSMa"
      },
      isRewardStart: false,
      showImg: '',
      showImgShow: false,
      codeImg: require('../../../../assets/images/active/mitu/order/pop/code.png'),
      codeImgShow: false,
      sureImg: require('../../../../assets/images/active/mitu/order/pop/sureText.png'),
      sureShow: false,
      copyShow: false,
      copyImg: require('../../../../assets/images/active/mitu/order/pop/copy.png'),
      inviteSgin: true,
    };
  },
  created() {

    const { protocol, host } = window.location;
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    const code = this.$route.query.code;
    if (!code) {
        return window.location.href = `${protocol}//${host}/snail/fourth/enter/${getRandomString()}`
    }
    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛');
    this.logger = bl;
    this.logger.sum('最强蜗牛_四周年_领取奖励，进入分享页');

    this.logger = bl;
    this.messageImg = null
    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/mitu/order/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    this.getUserInfo()


    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
      console.log(this.isPC, '当前设备是 PC');
    } else {
      console.log('当前设备不是 PC');
    }
    this.incrementTo100()

  },
  mounted() {
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });

  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('oldValue------>', oldValue)
        console.log('newValue------>', newValue)
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {

            if (!newValue.account) {
              // TAG: 注销的时候
              // this.clearActiveInfo();
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
  },
  methods: {
    incrementTo100() {
      const target = 100;
      const duration = 300; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器   
        }
      }, stepTime);

    },
    teamInit() {
      const params = {
        code: this.$route.query.code
      }
      teamInit(params).then((res) => {
        if (res.code == 200) {
          console.log('队伍初始化')
        }
        console.log(res)
      })
    },
    item_click(item) {
      const { protocol, host } = window.location;
      if (item === 'offical') {
        this.logger.sum('最强蜗牛_四周年_领取奖励，分享页跳转主会场');
        return window.location.href = `${protocol}//${host}/snail/fourth/enter/${getRandomString()}`
      }
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }

      if (item === 'enter') {
        this.invite()
      }
    },

    invite() {
      if (!this.$route.query.code) return
      const that = this
      const params = {
        code: this.$route.query.code
      }
      invite(params).then(res => {
        this.logger.sum('最强蜗牛_四周年_领取奖励，加入组队');
        console.log(res)
        this.messageImg = null
        this.onToast(res.message)
        console.log(res.message)


      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        that.getUserInfo()
      })
    },

    scrollToElement(target) {
      const element = document.getElementById(target); // 获取目标元素
      element.scrollIntoView({
        behavior: 'smooth' // 使用平滑滚动效果（可选）
      });
    },
    // 复制链接w
    onCopy(my_id) {
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this.logger.sum('迷途之光_预约页_复制链接邀请好友');
      const clipboard = new Clipboard(my_id);
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        console.log(clipboard, 'success')
        this.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        this.showImg = require('../../../../assets/images/active/mitu/order/pop/copy_success.png'),
          this.showImgShow = true
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
    },

    initShareData() {
      try {
        const { protocol, host } = window.location;
        if (this.activity.code) {
          this.shareLink = `${protocol}//${host}/mitu/order/enter/${getRandomString()}?invitation_code=` + this.activity.code;
          this.$set(this, 'shareLink', this.shareLink)
          console.log('shareLink', this.shareLink);
          this.isSetShare(this.shareLink);
          // 例如：获取好友助力信息等
        }
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      const params = {
      }
      await onGetInitDataAPI(params).then(response => {
        that.preloadingShow = false;
        if (response.code === 200) {
          that.activity = response.data.activity

          this.rewardSum = response.data.activity.task_info.number
          that.isUserInfo = true
          that.initShareData();
          that.onInitState(response);

          that.task_info = response.data.activity.task_info
          that.user_info = response.data.user_info;
          if (this.$route.query.code && that.inviteSgin) {
            that.teamInit()
            that.inviteSgin = false
          }
        } else {
          that.isUserInfo = false
          that.onToast(response.message);
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
        that.preloadingShow = false;
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        this.setUserInfo(response.data.user_info);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.isLogin = false; // 是否登录，用于判断是否显示登录弹窗等
      this.isSelectRole = false; // 是否选择角色，用于判断是否显示选择角色弹窗等
      this.isSelectServer = false; // 是否选择服务器，用于判断是否显示选择服务器弹窗等
      this.helpSign = false

      this.task_list = [
        {
          "id": 1,
          "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
          "status": false,
          "package_id": 1,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 2,
          "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
          "status": false,
          "package_id": 2,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 3,
          "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
          "status": false,
          "package_id": 3,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 4,
          "name": "\u9080\u8bf7\u597d\u53cb",
          "status": false,
          "package_id": 4,
          "num": 2,
          "is_get_reward": false
        }
      ]
      this.activity = {
        "invitation": [
        ],
        "task_list": [
          {
            "id": 1,
            "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
            "status": false,
            "package_id": 1,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 2,
            "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
            "status": false,
            "package_id": 2,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 3,
            "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
            "status": false,
            "package_id": 3,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 4,
            "name": "\u9080\u8bf7\u597d\u53cb",
            "status": false,
            "package_id": 4,
            "num": 2,
            "is_get_reward": false
          }
        ],
        "code": "feHrfhzH",
        "reward_start": false,
        "url_scheme": "weixin:\/\/dl\/business\/?t=o4RzaIEHSMa"
      },
        this.$set(this, 'task_list', this.task_list)
      this.setInitUserInfo();
      this.setInitActiveInfo();
      console.log(this.userInfo, '注销')
    },
    LoginCallBack() {
      console.log(arguments, '登录回调')
    },
    // 选择角色后
    selectCallback() {
      // 初始化
      this.priceShow = true
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
      console.log(this.selectInfo, '选择角色信息')
    },
    loginSuccess() {
      this.getUserInfo()
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
    },
    onOfficial() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      this.logger.sum('迷途之光_预约页_，前往下载');
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/fourth/enter${getRandomString()}`,
        title: '有梗有趣，还有蜗和鹂',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/Hmpg68XTBbVFL9n0HyLdNp48EdiWf8mCBSx2naIz.png',
        desc: '有梗有趣，还有蜗和鹂，6月21日四周年来袭！！'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/fourth/help/index.vue